import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { logOut, setAccessToken } from "../../features/auth/authSlice";
import {
  storageDelete,
  storageLoad,
  storageSave,
} from "../../utils/localStorage";
console.log("10 env:", process.env);
const useLogoutMutation = []
const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_ENDPOINT,
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth.token;
    const orgId = storageLoad("selected-organization-id") || getState().auth.organizationId;
    if (token) {
      console.log("Organization-ID", orgId);
      const orgHeaders = {
        "TPO-ORG-ID": orgId?.toString() || "",
      };
      headers.set("Authorization", `Bearer ${token}`);
      headers.set("Accept", "application/json");
      if (!headers.has("TPO-ORG-ID")) {
        headers.set("TPO-ORG-ID", orgHeaders["TPO-ORG-ID"]);
      }
    }
    return headers;
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);
  const refreshToken = storageLoad("refresh-token");
  console.log("38 refresh token:", refreshToken);

  var formData = new FormData();
  formData.append("refresh", refreshToken);

  console.log("35 result:", result);

  if (result?.error?.status === 401) {
    console.log("sending refresh token", result?.error);
    // send refresh token to get a new access token
    const refreshResult = await baseQuery(
      {
        url: "/api/token/refresh/",
        method: "POST",
        body: formData,
      },
      api,
      extraOptions
    );
    console.log("38 refresh:", refreshResult);
    console.log("38 refresh data:", refreshResult?.data);

    if (
      refreshToken !== null &&
      refreshResult?.data === undefined &&
      (refreshResult?.error?.data?.detail?.includes("invalid") ||
        refreshResult?.error?.data?.detail?.includes("expired"))
    ) {
      console.log("45 log out");
      storageDelete("access-token");
      storageDelete("refresh-token");
      api.dispatch(logOut());

      window.location.reload();
    }

    console.log("75 refreshed access token", refreshResult?.data?.access);

    if (refreshResult?.data) {
      // store the new token
      api.dispatch(setAccessToken(refreshResult?.data?.access));
      storageSave("access-token", refreshResult?.data?.access);

      // retry the original query with the new access token
      result = await baseQuery(args, api, extraOptions);
    } else {
      api.dispatch(logOut());
    }
  }

  return result;
};

export const apiSlice = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({}),
});

export const getOrganizationIdFromName = (organizationName, userDetails) => {
  if (!userDetails?.organizations || userDetails.organizations.length === 0) {
    return null;
  }

  // Decode the organization name if it's URL encoded
  const decodedOrgName = organizationName ? decodeURIComponent(organizationName) : "";

  // Find the organization that matches the name
  const matchingOrg = userDetails.organizations.find(
    (org) => org.name === decodedOrgName
  );

  return matchingOrg ? matchingOrg.id : null;
};
